/** The AutoCAD Color Index — 256 entries, index 0..255.
 *
 * ⚠⚠ **GENERATED FROM `ezdxf.colors.DXF_DEFAULT_COLORS`, WHICH IS ALSO WHAT THE BACKEND RENDERS
 * WITH.** Hand-typing this table is how a drawing comes out nearly the right colour: the ramp
 * from 10 to 249 is 24 hues x 10 shades and nobody notices one wrong shade until a client does.
 * One source, two consumers.
 *
 * ⚠ Index 0 is ByBlock and 256 is ByLayer — NEITHER is a colour. A renderer that looks either
 * one up in this table draws black on black. `aciToCss` refuses both.
 */

const ACI: readonly number[] = [
  0x000000, 0xff0000, 0xffff00, 0x00ff00, 0x00ffff, 0x0000ff, 0xff00ff, 0xffffff,
  0x808080, 0xc0c0c0, 0xff0000, 0xff7f7f, 0xa50000, 0xa55252, 0x7f0000, 0x7f3f3f,
  0x4c0000, 0x4c2626, 0x260000, 0x261313, 0xff3f00, 0xff9f7f, 0xa52900, 0xa56752,
  0x7f1f00, 0x7f4f3f, 0x4c1300, 0x4c2f26, 0x260900, 0x261713, 0xff7f00, 0xffbf7f,
  0xa55200, 0xa57c52, 0x7f3f00, 0x7f5f3f, 0x4c2600, 0x4c3926, 0x261300, 0x261c13,
  0xffbf00, 0xffdf7f, 0xa57c00, 0xa59152, 0x7f5f00, 0x7f6f3f, 0x4c3900, 0x4c4226,
  0x261c00, 0x262113, 0xffff00, 0xffff7f, 0xa5a500, 0xa5a552, 0x7f7f00, 0x7f7f3f,
  0x4c4c00, 0x4c4c26, 0x262600, 0x262613, 0xbfff00, 0xdfff7f, 0x7ca500, 0x91a552,
  0x5f7f00, 0x6f7f3f, 0x394c00, 0x424c26, 0x1c2600, 0x212613, 0x7fff00, 0xbfff7f,
  0x52a500, 0x7ca552, 0x3f7f00, 0x5f7f3f, 0x264c00, 0x394c26, 0x132600, 0x1c2613,
  0x3fff00, 0x9fff7f, 0x29a500, 0x67a552, 0x1f7f00, 0x4f7f3f, 0x134c00, 0x2f4c26,
  0x092600, 0x172613, 0x00ff00, 0x7fff7f, 0x00a500, 0x52a552, 0x007f00, 0x3f7f3f,
  0x004c00, 0x264c26, 0x002600, 0x132613, 0x00ff3f, 0x7fff9f, 0x00a529, 0x52a567,
  0x007f1f, 0x3f7f4f, 0x004c13, 0x264c2f, 0x002609, 0x135817, 0x00ff7f, 0x7fffbf,
  0x00a552, 0x52a57c, 0x007f3f, 0x3f7f5f, 0x004c26, 0x264c39, 0x002613, 0x13581c,
  0x00ffbf, 0x7fffdf, 0x00a57c, 0x52a591, 0x007f5f, 0x3f7f6f, 0x004c39, 0x264c42,
  0x00261c, 0x135858, 0x00ffff, 0x7fffff, 0x00a5a5, 0x52a5a5, 0x007f7f, 0x3f7f7f,
  0x004c4c, 0x264c4c, 0x002626, 0x135858, 0x00bfff, 0x7fdfff, 0x007ca5, 0x5291a5,
  0x005f7f, 0x3f6f7f, 0x00394c, 0x26427e, 0x001c26, 0x135858, 0x007fff, 0x7fbfff,
  0x0052a5, 0x527ca5, 0x003f7f, 0x3f5f7f, 0x00264c, 0x26397e, 0x001326, 0x131c58,
  0x003fff, 0x7f9fff, 0x0029a5, 0x5267a5, 0x001f7f, 0x3f4f7f, 0x00134c, 0x262f7e,
  0x000926, 0x131758, 0x0000ff, 0x7f7fff, 0x0000a5, 0x5252a5, 0x00007f, 0x3f3f7f,
  0x00004c, 0x26267e, 0x000026, 0x131358, 0x3f00ff, 0x9f7fff, 0x2900a5, 0x6752a5,
  0x1f007f, 0x4f3f7f, 0x13004c, 0x2f267e, 0x090026, 0x171358, 0x7f00ff, 0xbf7fff,
  0x5200a5, 0x7c52a5, 0x3f007f, 0x5f3f7f, 0x26004c, 0x39267e, 0x130026, 0x1c1358,
  0xbf00ff, 0xdf7fff, 0x7c00a5, 0x9152a5, 0x5f007f, 0x6f3f7f, 0x39004c, 0x42264c,
  0x1c0026, 0x581358, 0xff00ff, 0xff7fff, 0xa500a5, 0xa552a5, 0x7f007f, 0x7f3f7f,
  0x4c004c, 0x4c264c, 0x260026, 0x581358, 0xff00bf, 0xff7fdf, 0xa5007c, 0xa55291,
  0x7f005f, 0x7f3f6f, 0x4c0039, 0x4c2642, 0x26001c, 0x581358, 0xff007f, 0xff7fbf,
  0xa50052, 0xa5527c, 0x7f003f, 0x7f3f5f, 0x4c0026, 0x4c2639, 0x260013, 0x58131c,
  0xff003f, 0xff7f9f, 0xa50029, 0xa55267, 0x7f001f, 0x7f3f4f, 0x4c0013, 0x4c262f,
  0x260009, 0x581317, 0x000000, 0x656565, 0x666666, 0x999999, 0xcccccc, 0xffffff,
];

/** AutoCAD's model-space background. Colour 7 is drawn WHITE on this and black on paper. */
export const ACAD_BG = "#1a1a1a";

/** An entity colour -> a CSS colour, resolved against its layer.
 *
 * ⚠⚠ **256 IS ByLAYER AND 0 IS ByBLOCK, AND BOTH ARE THE COMMON CASE, NOT THE EDGE CASE.** Most
 * entities in a real drawing carry 256; a table lookup would paint the whole drawing black.
 * ⚠ Colour 7 flips with the background — white on dark, black on light — which is AutoCAD's own
 * behaviour and the reason a drawing does not vanish when a drafter switches to a light theme.
 */
export function aciToCss(color: number | undefined, layerAci: number,
                         layerRgb: number | null, dark = true): string {
  let aci = color === undefined || color === 256 || color === 0 ? layerAci : color;
  if ((color === undefined || color === 256 || color === 0) && layerRgb != null)
    return rgbToCss(layerRgb);
  if (aci === 7) return dark ? "#ffffff" : "#000000";
  if (aci < 0) aci = -aci;                       // a negative ACI means the layer is OFF
  if (aci < 1 || aci > 255) return dark ? "#ffffff" : "#000000";
  return rgbToCss(ACI[aci]);
}

export function rgbToCss(v: number): string {
  return "#" + (v & 0xffffff).toString(16).padStart(6, "0");
}
